import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { environment } from '../../../../../../environments/environment';
import { AnalyticsService } from '../../../../services/analytics.service';
import { ANALYTICS_ACTIONS_DICT, ANALYTICS_CATEGORY_DICT } from '../../../../utils/analytics-actions-dict';

declare let hj: any;

@Component({
  selector: 'sh-main-nav-request-demo',
  templateUrl: './main-nav-request-demo.component.html',
  styleUrl: './main-nav-request-demo.component.scss',
  standalone: false
})
export class MainNavRequestDemoComponent implements OnInit {
  @Output() closeMenu = new EventEmitter();

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit(): void {}

  openRequestForDemo(): void {
    // emmit event to close wrapping menu
    this.closeMenu.emit();
    // event for hotjar
    if (typeof hj === typeof Function) {
      hj('event', 'request-demo');
    }

    this.analyticsService.sendEvent(ANALYTICS_CATEGORY_DICT.DEMO, ANALYTICS_ACTIONS_DICT.DEMO_SCHEDULE);
    window.location.href = environment.pipeDriveDemoLink;
  }
}
